import { useQuery, useMutation } from '@tanstack/react-query';
import marketCategoryService from 'api/marketCategoryService';

export const useAllMarketCategories = () => {
    return useQuery({
        queryKey: ['allCategories'],
        queryFn: () => marketCategoryService.all(),
        staleTime: 10 * 60 * 1000 // cache for 10 mins
    });
};

export const useMarketCategory = (id) => {
    return useQuery({
        queryKey: ['category', id],
        queryFn: () => marketCategoryService.get(id),
        enabled: !!id, // only run if id is provided
        staleTime: 10 * 60 * 1000 // cache for 10 mins
    });
};

export const useAdminAllMarketCategories = () => {
    return useQuery({
        queryKey: ['adminAllCategories'],
        queryFn: () => marketCategoryService.adminAll(),
        staleTime: 10 * 60 * 1000 // cache for 10 mins
    });
};

// Admin only hooks
export const useCreateMarketCategory = (options) => {
    return useMutation({
        mutationFn: marketCategoryService.create,
        ...options
    });
};

export const useUpdateMarketCategory = (options) => {
    return useMutation({
        mutationFn: ({ id, ...data }) => marketCategoryService.update(id, data),
        ...options
    });
};
